'use strict';
require('../stable');
require('../stage/3');

module.exports = require('../internals/path');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/actual/index.js
// module id = 691
// module chunks = 31